export function getDenialReasonText(reservation, t) {
  const key = reservation?.denial_reason_key;
  if (key) {
    const translated = t(`loyalty.reservations.denialPresets.${key}`, { defaultValue: '' });
    if (translated) {
      return translated;
    }
  }

  return reservation?.denial_reason?.trim() || '';
}

export function hasDenialReason(reservation) {
  if (reservation?.denial_reason_key) {
    return true;
  }

  return Boolean(reservation?.denial_reason?.trim());
}
